import { Modal } from "components/ui/modal";
import { SystemStatus } from "screens/settings/tabs/system-status";
import { SystemStatus as ISystemStatus } from "types/system-status";

type SystemStatusModalProps = {
  show: boolean;
  onClose: () => void;
  status: ISystemStatus | null;
};

export const SystemStatusModal = ({
  show,
  onClose,
}: SystemStatusModalProps) => {
  return (
    <Modal
      show={show}
      onClose={onClose}
      title="System Status"
      className="w-full h-full"
      showCloseButton
    >
      <SystemStatus title="" />
    </Modal>
  );
};
